import { t } from '@lingui/core/macro';
import { NoddiCard, NoddiSkeleton } from 'noddi-ui-web';
import { InstructionRow } from '../Common/InstructionRow';

export const TireOfferNextInstructions = ({
  hasActiveTireHotelContractForWheelSet,
  isPending
}: {
  hasActiveTireHotelContractForWheelSet?: boolean;
  isPending?: boolean;
}) => {
  return (
    <NoddiCard title={t`What happens next?`} contentClassName='flex flex-col gap-4'>
      <InstructionRow
        icon='Check'
        title={t`Order confirmation`}
        description={t`You'll receive an SMS confirmation with your order details within the next few minutes.`}
      />
      <InstructionRow
        icon='Clock'
        title={t`Order processing`}
        description={t`Our team will process your order immediately and prepare your tires for shipment and installation. You will receive an SMS with estimated delivery time.`}
      />
      {isPending ? (
        <NoddiSkeleton className='h-10 w-full' />
      ) : (
        <TireOfferMountingInstructions
          hasActiveTireHotelContractForWheelSet={!!hasActiveTireHotelContractForWheelSet}
        />
      )}
    </NoddiCard>
  );
};

const TireOfferMountingInstructions = ({
  hasActiveTireHotelContractForWheelSet
}: {
  hasActiveTireHotelContractForWheelSet: boolean;
}) =>
  hasActiveTireHotelContractForWheelSet ? (
    <InstructionRow
      icon='Wrench'
      title={t`Tire mounting`}
      description={t`When your tires are ready, we will mount them on your rims at our facility. Then your new tires are ready to roll!`}
    />
  ) : (
    <InstructionRow
      icon='Calendar'
      title={t`Appointment Scheduling`}
      description={t`When your tires are ready, we will contact you to schedule the installation.`}
    />
  );
